










































import DateFormat from '@/shared/utils/date-format';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SelectMultipleMonth extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) disabled!: boolean;

  @Prop() months!: string[];

  @Prop({ default: () => ([]) }) rules!: Array<Function>;

  @Prop({ default: () => () => true }) allowedDates!: Function;

  pickerMenu: boolean = false;

  get monthsFormatted() {
    const dates: string[] = this.months
      .map((el: string) => DateFormat.localDateToLocal(el));
    return dates.map((el: string) => DateFormat.fullMonthAndYear(el));
  }

  change(value: string[]) {
    this.$emit('change', value)
  }
}
